<template>
  <v-card flat>
    <h1>{{ $t('application.information.title') }}</h1>
    <p class="mb-8">{{ $t('application.information.info') }}</p>
    <v-form ref="form" v-model="valid" lazy-validation>
      <!-- Display personal information data -->
      <v-text-field
        outlined
        :rules="[rules.required]"
        v-model="application.firstName"
        :label="$t('fields.firstName')"
      ></v-text-field>

      <v-text-field
        outlined
        :rules="[rules.required]"
        v-model="application.lastName"
        :label="$t('fields.lastName')"
      ></v-text-field>

      <v-text-field
        outlined
        :rules="[rules.required]"
        v-model="application.address1"
        :label="$t('fields.address')"
      ></v-text-field>

      <v-text-field v-model="application.address2" :label="$t('fields.address2')" outlined></v-text-field>

      <v-text-field
        outlined
        v-model="application.zip"
        :label="$t('fields.zip')"
        :rules="[rules.required, rules.integer, rules.hasLength(5, application.zip)]"
      ></v-text-field>

      <v-text-field
        class="mb-n5"
        :rules="[rules.required]"
        outlined
        v-model="application.city"
        :label="$t('fields.city')"
      ></v-text-field>
      <!-- Display different message for next step button based on (its company application or apprentice application) -->
      <!-- <div v-if="loGet(selectedApplication, 'isCompanyApplication')">
        <NextButton @click="nextStep">{{ $t('labels.document-next-step') }}</NextButton>
      </div> -->
      <div>
        <NextButton @click="nextStep">{{ $t('tour.next') }}</NextButton>
      </div>
      <!-- Go to a previous  step-->
      <BottomNav @clicked="$emit('goToStep', '-1')" />
    </v-form>
  </v-card>
</template>

<script>
// Entryform for unknown user to become a apprentice
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import omit from 'lodash/omit'
import get from 'lodash/get'
import {RulesMixin} from '@/components/mixins'
import NextButton from '@/components/Common/NextButton'
import BottomNav from '@/components/Application/BottomNav'

// @group Application-Apprentice
// ApplicationInformation component
export default {
  name: 'ApplicationInformation',

  mixins: [RulesMixin],

  components: {
    NextButton,
    BottomNav
  },

  data: () => ({
    application: null,
    isRequired: false,
    fields: ['id', 'firstName', 'lastName', 'address1', 'address2', 'zip', 'city', 'email', 'mobilephone', 'step'],
    valid: true
  }),

  created() {
    //Call init application
    this.initApplication()
  },

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication and call initApplication
     * @arg called with no argument
     */
    selectedApplication: {
      handler: function () {
        this.initApplication()
      },
      deep: true
    },
    /**
     * @vuese
     * Used to watch the currentStep and call initApplication
     * @arg called with no argument
     */
    currentStep: {
      handler: function () {
        this.initApplication()
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication']),
    ...mapGetters('currentuser', ['currentUser'])
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication', 'updateSelectedApplication']),
    ...mapActions('currentuser', ['updateCurrentUserData']),

    /**
     * @vuese
     * Used to Initialize application with either selected or empty application
     */
    initApplication() {
      //- Initialize application with either selected or empty application
      if (get(this, 'selectedApplication.id')) {
        this.application = pick(this.selectedApplication, this.fields)
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
      }

      //- Used to add defaults if the application is initiated by the company
      if (this.currentUser && get(this, 'selectedApplication.isCompanyApplication')) {
        this.application.personalNumber = this.currentUser.personalNumber
        this.application.firstName = this.currentUser.firstName
        this.application.lastName = this.currentUser.lastName
        this.application.address1 = this.currentUser.address1
        this.application.address2 = this.currentUser.address2
        this.application.zip = this.currentUser.zip
        this.application.city = this.currentUser.city
        this.application.country = this.currentUser.country
      }
      this.application.step = this.currentStep
    },
    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new criterias
     * @arg The argument is an integer value application company id and params are the information fields
     */
    async nextStep() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', this.$t('errors.form-validation'))
        return
      }

      this.application.email = this.application.email || this.currentUser.email
      this.application.mobilephone = this.application.mobilephone || this.currentUser.mobilephone

      if((!this.application.email || !this.application.mobilephone))
      {
        this.$events.fire('showError', this.$t('errors.email-phone-missing'))
        return
      }

      if (this.application.id && this.application.id > 0) {
        const personData = omit(this.application, ['id', 'step'])
        Promise.all([
          API.updateApplication(this.application.id, {data: this.application}),
          API.updatePerson({data: personData})
        ])
          .then(([applicationResponse, personResponse]) => {
            this.updateSelectedApplication(this.application)
            this.updateCurrentUserData(personResponse.data)
            // Fire 6 if his company application or +1 if it is apprentice application
            // @arg The argument is a integer representing (in which step to go)
            if (get(this, 'selectedApplication.isCompanyApplication', false)) {
              this.$emit('goToStep', '+3')
            } else {
              this.$emit('goToStep', '+1')
            }
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
          })
      }
    }
  }
}
</script>

<style scoped>
</style>
